import React, {useState, useEffect, useLayoutEffect} from 'react';
import './home.css'
import '../../App.css'
import AnimateIn from '../../screens/components/AnimateIn';
import InViewComponent from '../../screens/components/InView';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../hook/UseLang';
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg'
import CONTENT from '../../contents/home'
import BTN from '../../contents/btn'
import CaroNextSvg from '../../svgs/home/CaroNextSvg.js'
import ReactCompareImage from 'react-compare-image';

import { set } from 'date-fns';

const Home2 = () => {
    const navigate = useNavigate()
    const text1Ref = React.useRef(null);
    const [lang, setLang] = useLang()
    const [topImgIdx, setTopImgIdx] = useState(0);
    const handleChangeImgIdx = (num) => {
        setTopImgIdx((prevIdx) => {
            return prevIdx + num < 0 ? 2 : (prevIdx + num) % 3
        })
    }
    useLayoutEffect(() => {
        console.log('trigger')
        const timer = setTimeout(() => {
            setTopImgIdx((prevIdx) => (prevIdx + 1) % 3);
        },5000)
        return () => clearTimeout(timer);
    },[topImgIdx])
    const old = (            
        <div className='w-full min-h-[97vh] relative bg-white'>
            <img src='./images/bg_texture.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img>

            <div className='relative w-full h-full flex flex-row-col items-center justify-center two-k-gap-240' style={{zIndex:2, gap:24}}>
                <div className='flex flex-col items-end-start justify-center' style={{flex:0.5}}>
                    <div className='flex flex-col items-start justify-center px-[24px] max-w-[400px]' style={{flex:1}}>
                        <div ref={text1Ref} className='w-[100%] max-w-[400px] flex flex-col items-start justify-center title_text' style={{gap: 24}}>
                            <div className='text-homesec-title mb-[24px] playfair-display' style={{letterSpacing:5}}>{CONTENT.sec2_0[lang]}</div>
                            <div className='text-d-12'>
                                <div>{CONTENT.sec2_1[lang]}</div> 
                            </div>
                            <div className='text-d-12'>
                                <div>{CONTENT.sec2_2[lang]}</div>
                            </div>
                            <div className='text-d-12'>
                                <div>{CONTENT.sec2_3[lang]}</div>
                            </div>
                            <div className='text-d-12'>
                                <div>{CONTENT.sec2_4[lang]}</div>
                            </div>
                            {/* <div onClick={() => navigate(`/concept?lang=${lang}`)} className='mt-[24px] text-d-12 cursor-pointer select-none border-b border-b-1px border-black pr-[8px] hover:font-bold' style={{textDecoration:'underline'}}>details</div> */}
                        </div>
                        <div onClick={() => navigate(`/concept?lang=${lang}`)} className='mt-[48px] relative text-d-12 flex flex-row items-center justify-center w-[90%] max-w-[208px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300 btn-arrow'>
                            <div className='relative'>{BTN.details[lang]}</div>
                            <div className='absolute right-[-16%] top-[46%] arrow-moveleft'>
                                <Sec4ArrowSvg/>
                            </div>
                        </div>
                        <InViewComponent reffing={text1Ref} active='title_text_active' />
                    </div>
                </div>
                <div className='flex flex-row items-center justify-start-center h-full' style={{flex:1}}>
                    {/* <AnimateIn delay={0} className='flex flex-row items-center justify-center'>
                        <img src='./images/home/sec2.jpg' className='home-1-img-width' style={{aspectRatio:752/831, height:undefined, width:'60%'}}></img>
                    </AnimateIn> */}
                    <div className='w-[90%] h-[50%] relative compare-img-div'>
                        <ReactCompareImage leftImageCss={{objectPosition:'50% 60%'}} rightImageCss={{objectPosition:'50% 60%'}} leftImage={`./images/home/slider/0.jpg`} rightImage={`./images/home/slider/1.jpg`}/>
                    </div>
                </div>
            </div>
        </div>)
    return (
        <div className='w-full min-h-[97vh] relative bg-black'>
            <link rel="preload" as="image" href="./images/home/slider/0.jpg" fetchPriority='high'/>
            <link rel="preload" as="image" href="./images/home/slider/1.jpg" fetchPriority='high'/>
            {/* <CaroNextSvg onClick={() => handleChangeImgIdx(-1)} className='rotate-[180deg] absolute top-[50%] left-[3%]' style={{zIndex:9}}/>
            <CaroNextSvg onClick={() => handleChangeImgIdx(1)} className='absolute top-[50%] right-[3%] ' style={{zIndex:9}}/> */}
            {/* <img src='./images/bg_texture.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img> */}
            <div className='w-full h-full relative compare-img-div'>
                <ReactCompareImage sliderLineColor='#96805D' leftImageCss={{objectPosition:'50% 60%'}} rightImageCss={{objectPosition:'50% 60%'}} leftImage={`./images/home/slider/0.jpg`} rightImage={`./images/home/slider/1.jpg`}/>
            </div>
            {/* <img key={topImgIdx} src={`./images/home/home_${topImgIdx}.jpg`} className='h-full w-full homechange absolute' style={{ objectFit: 'cover'}}></img> */}
            {/* <div className='relative w-full h-full flex flex-row-col items-center justify-center two-k-gap-240' style={{zIndex:2}}>
            </div> */}
        </div>
    );
};

export default Home2;